module.exports = __webpack_public_path__ + "advantages-2.jpg";